import { Outlet } from "@tanstack/react-router";
// Import Context
import { AuthorisationProvider } from "./contexts/AuthorisationContext";
import { AlertNotificationProvider } from "./contexts/AlertNotificationContext";
import { ChatProvider } from "./contexts/ChatContext";
import { UserProvider } from "./contexts/UserContext";
// MSAL imports
import { MsalProvider } from "@azure/msal-react";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";
import { msalInstance } from "./msalInstance";
// React-query imports
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
const queryClient = new QueryClient();
// Page Imports
import { PageLayout } from "./components/PageLayout";
import { ErrorComponent } from "./components/ErrorComponent";
import { Loading } from "./components/Loading";

const authRequest = { ...loginRequest };

/**
 * The application shell. Rendered by the root route, with <Outlet /> standing
 * in for whichever page the router matched.
 *
 * MSAL's navigation client is wired up in main.jsx rather than here: the
 * TanStack router instance exists outside React, so it no longer has to be
 * reached through a hook. That removed the old ClientSideNavigation wrapper,
 * which suppressed its own first render because react-router v6 could not
 * navigate during it.
 */
function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={authRequest}
        errorComponent={ErrorComponent}
        loadingComponent={Loading}
      >
        <QueryClientProvider client={queryClient}>
          <AuthorisationProvider>
            <UserProvider>
              <AlertNotificationProvider>
                <ChatProvider>
                  <PageLayout>
                    <Outlet />
                  </PageLayout>
                </ChatProvider>
              </AlertNotificationProvider>
            </UserProvider>
          </AuthorisationProvider>
          {/* Dev only. import.meta.env.DEV is statically replaced, so the
              devtools are tree-shaken out of production builds entirely. */}
          {import.meta.env.DEV && (
            <ReactQueryDevtools
              initialIsOpen={false}
              buttonPosition="bottom-left"
            />
          )}
        </QueryClientProvider>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
}

export default App;
